import type { FormColumn, FormField, FormSchema } from '@cli-types/core-engine/schema.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { displayLabel } from './display-label.js'
import { formColumnTypeForField } from './form-column-type-for-field.js'
import { promptConfirm } from './prompt-confirm.js'

export async function promptFormColumnOption(
  context: SchemaPromptContext,
  schema: FormSchema,
  field: FormField
): Promise<string[]> {
  const columnType = formColumnTypeForField(field)
  if (!field.name || !columnType) {
    return []
  }

  const addColumn = await promptConfirm(
    context,
    'Add this field to submission admin columns?',
    false
  )
  if (!addColumn) {
    return []
  }

  schema.columns = schema.columns ?? []
  const column: FormColumn = {
    accessorKey: field.name,
    header: displayLabel(field),
    type: columnType
  }
  schema.columns.push(column)
  return [`submission column: ${field.name}`]
}
